import $ from 'jquery';

import 'bootstrap';

import 'application/config';

import 'application/routes';

import 'application/run';

import 'application/values/values';

import 'application/directives/directives';

import 'application/filters/filters';

import 'application/services/services';

import 'application/factories/factories';

import 'ng-notify/dist/ng-notify.min';

// Código global.

$(document)

	.on('shown.bs.modal', '.modal', function() {

		$(this).find('[autofocus]:first').trigger('focus');

	});
